import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../services/api';
import {
  consumirMensajeSesion,
  guardarSesion,
  obtenerTokenSesion
} from '../utils/sesion';

function LoginPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    Usuario: '',
    Password: ''
  });

  const [mensaje, setMensaje] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const mensajeSesion = consumirMensajeSesion();

    if (mensajeSesion) {
      setMensaje(mensajeSesion);
    }

    const token = obtenerTokenSesion();

    if (token) {
      navigate('/dashboard', {
        replace: true
      });
    }
  }, [navigate]);

  function handleChange(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setMensaje('');
    setLoading(true);

    try {
      const response = await api.post('/auth/login', form);

      guardarSesion(response.data.token, response.data.usuario);

      navigate('/dashboard', {
        replace: true
      });
    } catch (error) {
      console.log('LOGIN ERROR:', error.response?.data || error.message);

      setMensaje(
        error.response?.data?.mensaje ||
        error.message ||
        'Error al iniciar sesión.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: '100vh',
        background: '#f1f5f9'
      }}
    >
      <div
        className="card shadow-sm"
        style={{
          width: '420px',
          borderRadius: '16px'
        }}
      >
        <div className="card-body p-4">

          <div className="text-center mb-4">
            <img
              src="/logo-app.png"
              alt="Sistema Control Recibos"
              style={{
                width: '78px',
                height: '78px',
                objectFit: 'contain',
                marginBottom: '12px'
              }}
            />

            <h2
              className="fw-bold mb-1"
              style={{
                fontSize: '34px',
                color: '#1f2937'
              }}
            >
              Control Recibos
            </h2>

            <div
              className="text-muted"
              style={{
                fontSize: '16px'
              }}
            >
              Inicio de sesión
            </div>
          </div>

          {mensaje && (
            <div className="alert alert-danger">
              {mensaje}
            </div>
          )}

          <form onSubmit={handleSubmit}>

            <div className="mb-3">
              <label className="form-label fw-semibold">
                Usuario
              </label>

              <input
                type="text"
                name="Usuario"
                className="form-control"
                value={form.Usuario}
                onChange={handleChange}
                autoComplete="off"
                required
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">
                Contraseña
              </label>

              <input
                type="password"
                name="Password"
                className="form-control"
                value={form.Password}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? 'Ingresando...' : 'Ingresar'}
            </button>

          </form>

          <div className="mt-4 text-muted small">
            Administrador y Operador
          </div>

        </div>
      </div>
    </div>
  );
}

export default LoginPage;
